import { render, staticRenderFns } from "./problemType.vue?vue&type=template&id=62524ae4&scoped=true"
import script from "./problemType.vue?vue&type=script&lang=js"
export * from "./problemType.vue?vue&type=script&lang=js"
import style0 from "./problemType.vue?vue&type=style&index=0&id=62524ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62524ae4",
  null
  
)

export default component.exports